import React from 'react';
import RecipeDesserts from '../../components/RecipeDesserts';

const Vegetarian = () => {
  return (
    <div className="home-page">
      <RecipeDesserts />
    </div>
  );
};

export default Vegetarian;